<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import vue2Dropzone from 'vue2-dropzone'

const USERS_API_URL = process.env.VUE_APP_API_URL + 'users/';
const DASHBOARD_API_URL = process.env.VUE_APP_API_URL + 'dashboard/';

import {
  required,
  minLength
} from 'vuelidate/lib/validators'

import * as axios from "axios";

const PUBLISHERS_API_URL = process.env.VUE_APP_API_URL + 'publishers/';

const roles = [
        {
            name: 'admin',
            id: 1,
        }, {
            name: 'user',
            id: 2,
        }, {
            name: 'eyeo',
            id: 3,
        }, {
            name: 'media buyer',
            id: 4,
        },
        {
            name: 'account manager',
            id: 5,
        },
        {
            name: 'trafficker',
            id: 6,
        },
        {
            name: 'finance',
            id: 7,
        },
    ];

/**
 * Create user form component
 */
export default {
  page: {
    title: 'User Form',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    vueDropzone: vue2Dropzone,
    Layout,
    PageHeader,
    Multiselect
  },
  data() {
    return {
      title: 'User Form',
      items: [
                    {
                        text: 'Unblockia',
                        href: '/',
                    },
                    {
                        text: 'Users',
                        href: '/admin/users',
                    },
                    {
                        text: '',
                        active: true,
                    },
                ],
      user: {
        name: '',
        lastname: '',
        email: '',
        role: '',
        publisher: '',
        dashboardSendDate: '',
      },
      roles,
      publishers: [],
      submitted: false,
      showmodal: false,
      dashboardSent: false,
      submitStatus: '',
      isSending: false,
      isSent: false,
      sendingIsFailed: false,
      timer: null,
      password:{
         newPassword: '',
         confirmPassword: ''
      },
      passwordSubmitted: false,
      passwordSubmitStatus: '',
      emailError: '',
      dropzoneOptions: {
        url: `${USERS_API_URL}${this.$route.params.id}/uploadToS`, // File upload endpoint, not signed url endpoint
        thumbnailWidth: 300,
        headers:  { 'Authorization': 'Bearer ' + JSON.parse(localStorage["auth.currentUser"]).token },
        maxFilesize: 0.5,
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME"
      },
      copyAlertDismissCountDown: 0
    }
  },
  validations: {
    user: {
      name: { required },
      email: { required },
      role: { required },
    },
    password: {
      newPassword: {required, minLength: minLength(6) },
      confirmPassword: {required}
    }
    
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id
    },
    isAdmin: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "admin"
    }
  },
  async mounted() {
    await this.fetchPublishers()

    if (this.isEdit) {
      const response = await axios(DASHBOARD_API_URL + 'users/' + this.$route.params.id)
      this.user = response.data
      this.dashboardSent = !!this.user.dashboardSendDate
    }

    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.hideModal()
    })
  },
  methods: {
    async fetchPublishers() {
      const fetchSitesResponse = await axios(PUBLISHERS_API_URL)
      this.publishers = fetchSitesResponse.data.results.map((item) => ({
        id: item.id,
        name: item.name,
      }))
    },
    handleSubmit(e) {
      this.submitted = true;
      this.emailError = '';
      // stop here if form is invalid
      this.$v.user.$touch()

      if (this.$v.user.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        // do your submit logic here
        this.submitStatus = 'PENDING'
        setTimeout(async () => {
          try {
            const data = {
              ...this.user,
              roleId: this.user.role.id,
            }
            const action = this.isEdit ? 'put' : 'post'
            const url = !this.isEdit
              ? USERS_API_URL
              // : USERS_API_URL + this.$route.params.id
              : DASHBOARD_API_URL + 'users/' + this.$route.params.id
            const response = await axios[action](url, data)
            if (!response.data.error){
                this.submitStatus = 'OK';
                this.$router.push('/admin/users')
            }else{
                this.submitStatus = 'ERROR'
                this.emailError = response.data.error.toString()
            }
          } catch (e) {
            console.log(e)
            this.submitStatus = 'ERROR'
          }
        }, 500)
      }
    },

    handlePasswordSubmit(){
      this.passwordSubmitted = true

      this.$v.password.$touch()

      if(this.$v.password.$invalid){
        this.passwordSubmitStatus = 'ERROR'
      }else{
        this.passwordSubmitStatus = 'PENDING'
        setTimeout(async () => {
          try {
            const data = {newPassword: this.password.newPassword}
            const action = 'put'
            const url = DASHBOARD_API_URL + 'users/' + this.$route.params.id + '/password'
            await axios[action](url, data)
            this.passwordSubmitStatus = 'OK'
          } catch(e){
            console.log(e)
            this.passwordSubmitStatus = 'ERROR'
          }
        })
      }
      
    },

    clickDashboardBtn() {
      this.showmodal = true
    },

    async sendDashboard() {
      this.isSending = true
      try {
        const response = await axios(
          USERS_API_URL + this.$route.params.id + '/send-dashboard'
        )
        this.isSending = false
        this.isSent = true
        this.sendingIsFailed = false
      } catch (e) {
        this.sendingIsFailed = true
        this.isSending = false
        console.log(e)
      }
    },

    hideModal() {
      this.showmodal = false
      this.timer = setTimeout(() => {
        this.isSent = false
        this.sending = false
        this.sendingIsFailed = false
      }, 500)

      clearTimeout(this.clearTime)
    },

    copyText() {
      const element = this.$refs.apiToken;
      element.select();
      element.setSelectionRange(0, 99999);
      document.execCommand('copy');
      this.copyAlertDismissCountDown = 1;
    },
    countDownChanged(dismissCountDown) {
      this.copyAlertDismissCountDown = dismissCountDown
    },

    goBack(e){
      e.preventDefault()
      this.$router.go(-1);
    },
    
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title">User</h4>
          <p class="sub-header"> Fill the information below </p>
          <b-alert show dismissible variant="danger" v-if="emailError">{{emailError}}</b-alert>
          <form @submit.prevent="handleSubmit">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>
                    Name
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="user.name"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.user.name.$error }"
                  />
                  <div
                    v-if="submitted && !$v.user.name.required"
                    class="invalid-feedback"
                  >
                    This value is required.
                  </div>
                </div>

                <div class="form-group">
                  <label>
                    Email
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="user.email.toLowerCase()"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.user.email.$error }"
                    @input="user.email = $event.target.value.toLowerCase()"
                  />
                  <div
                    v-if="submitted && !$v.user.email.required"
                    class="invalid-feedback"
                  >
                    This value is required.
                  </div>
                </div>

                <div class="form-group">
                  <div class="form-group">
                    <label>
                      Select a role
                      <span class="text-danger">*</span>
                    </label>
                    <multiselect
                      placeholder="Role"
                      v-model="user.role"
                      :options="roles"
                      label="name"
                      track-by="id"
                      :class="{ 'select-invalid': submitted && $v.user.role.$error }"
                    >
                    </multiselect>
                    <div
                    v-if="submitted && !$v.user.role.required"
                    class="select-error"
                  >
                    This value is required.
                  </div>
                  </div>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-6">
                <div class="form-group">
                  <label>Last name</label>
                  <input
                    v-model="user.lastname"
                    type="text"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label>Select a publisher</label>
                  <multiselect
                    placeholder="Publisher"
                    v-model="user.publisher"
                    :options="publishers"
                    label="name"
                    track-by="id"
                  >
                  </multiselect>
                </div>
                <div class="form-group" v-if="isEdit">
                  <label>API Token</label>
                  <b-input-group>
                    <b-form-input
                      ref="apiToken"
                      v-model="user.apiToken"
                      type="text"
                      class="form-control disabled-text"
                      disabled
                      
                    >
                    </b-form-input>
                    <b-input-group-append>
                      <b-button  @click="copyText()"><i class="mdi mdi-content-copy"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <b-alert
                    :show="copyAlertDismissCountDown"
                    variant="warning"
                    @dismissed="dismissCountDown=0"
                    @dismiss-count-down="countDownChanged"
                    class="copySuccessAlert"
                  >
                  Copied!
                </b-alert>
                  
                  
                </div>
              </div>
              
              <!-- end col -->
            </div>
            <div class="row">
              <div class="col-md-12 offset-12">
                <div class="form-group mb-0">
                  <div>
                    <b-button
                      class="btn ml-1 success"
                      variant="success"
                      v-b-modal.modal-1
                      v-if="isEdit"
                      @click="clickDashboardBtn"
                      >Send Dashboard
                    </b-button>

                    <b-modal
                      id="modal-1"
                      centered
                      title="Please confirm"
                      title-class="font-18"
                      hide-footer
                      v-model="showmodal"
                    >
                      <p v-if="!isSent && !sendingIsFailed"
                        >Are you sure you want to send the dashboard access to
                        <strong>{{ this.user.name }}</strong>?</p
                      >
                      <p v-if="!isSent && !sendingIsFailed">{{
                        dashboardSent
                          ? '(The dashboard has been sent before ✌)'
                          : '(The dashboard has not been sent 📈)'
                      }}</p>
                      <svg
                        v-if="isSent"
                        xmlns="http://www.w3.org/2000/svg"
                        data-name="Layer 1"
                        viewBox="0 0 100 125"
                        x="0px"
                        y="0px"
                      >
                        <g>
                          <path
                            d="M50,18A32,32,0,1,0,79.48,37.54,32,32,0,0,0,50,18Zm0,56A24,24,0,1,1,74,50,24,24,0,0,1,50,74Z"
                          />
                          <path
                            d="M46.77,52.41,39.68,46,34.32,52l10,9a4,4,0,0,0,5.58-.23l17-18-5.82-5.49Z"
                          />
                        </g>
                      </svg>
                      <p v-if="isSent" class="green">
                        The dashboard has been successfully sent !</p
                      >
                      <p v-if="sendingIsFailed" class="error">
                      Oh noooooo........ it looks like we encountered an error.
                      <br/>
                      Please try again, or contact our technical support.</p>
                      <br />
                      <button
                        class="btn btn-primary ml-1"
                        @click="sendDashboard"
                        v-if="!isSending && !isSent"
                        >Send</button
                      >
                      <b-button
                        variant="primary"
                        disabled
                        class="ml-1"
                        v-if="isSending && !isSent"
                      >
                        <b-spinner small type="grow"></b-spinner
                        >&nbsp;&nbsp;Sending...
                      </b-button>
                      <button
                        class="btn btn-secondary ml-1"
                        @click="hideModal"
                        >{{ isSent ? 'Close' : 'Cancel' }}</button
                      >
                    </b-modal>

                    <button
                      v-if="submitStatus !== 'PENDING'"
                      type="submit"
                      class="btn btn-primary ml-1"
                      >Submit
                    </button>
                    <b-button variant="primary" v-else disabled>
                      <b-spinner small></b-spinner>
                      <span>Submitting...</span>
                    </b-button>

                    <button @click="goBack" class="btn btn-secondary m-l-5 ml-1"
                      >Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <!-- end row -->
        </div>
      </div>

      <div class="col-lg-5" v-if="isEdit">
        <div class="card-box">
          <h4 class="header-title">Password</h4>
          <p class="sub-header"> Set new password </p>
          <form @submit.prevent="handlePasswordSubmit">
              <div class="form-group">
                  <label>
                       New password
                      <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="password.newPassword"                   
                    type="password"
                    class="form-control"
                    :class="{ 'is-invalid': passwordSubmitted && $v.password.newPassword.$error }"
                    @input="password.newPassword = $event.target.value.toLowerCase()"
                  />
                  <div
                    v-if="passwordSubmitted && !$v.password.newPassword.required"
                    class="invalid-feedback"
                  >
                    This value is required.
                  </div>
                  <div
                    v-if="passwordSubmitted && !$v.password.newPassword.minLength"
                    class="invalid-feedback"
                  >
                    The password must be at least 6 characters long.
                  </div>
              </div>

              <div class="form-group">
                  <label>
                       Confirm new password
                      <span class="text-danger">*</span>
                  </label>
                  <input
                  v-model="password.confirmPassword" 
                    type="password"
                    class="form-control"
                    :class="{ 'is-invalid': passwordSubmitted && ($v.password.confirmPassword.$error || password.newPassword !== password.confirmPassword) }"
                    @input="password.confirmPassword = $event.target.value.toLowerCase()"
                    
                  />
                  
                  <div
                    v-if="passwordSubmitted && !$v.password.confirmPassword.required"
                    class="invalid-feedback"
                  >
                    This value is required.
                  </div>

                  <div
                    v-if="passwordSubmitted && password.newPassword !== password.confirmPassword"
                    class="not-match"
                  >
                    Password not match.
                  </div>
              </div>

              <button 
                type="submit"
                class="btn btn-primary ml-1"
                v-if="passwordSubmitStatus !== 'PENDING'"
                >Change password
              </button>
              <b-button variant="primary" v-else disabled>
                <b-spinner small></b-spinner>
                <span>Submitting...</span>
              </b-button>
              <b-alert show dismissible variant="light"  v-if="passwordSubmitStatus === 'OK'">Password changed successfully.</b-alert>


              <!-- <p class="password-set" v-if="passwordSubmitStatus === 'OK'">Password changed successfully.</p> -->

          </form>
          <!-- end row -->
        </div>
      </div>

      <div class="col-lg-5" v-if="isAdmin">
        <div class="card-box">
          <h4 class="header-title">ToS File</h4>
            <vue-dropzone id="dropzone" ref="myVueDropzone" :options="dropzoneOptions" ></vue-dropzone>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
svg {
  width: 60px;
}
path {
  fill: #2AA800;
}
.green{
  color: #2AA800;
}
.error{
  color: #f1556c;
}
.not-match{
  color:#f1556c;
  font-size:0.75rem
}
.alert{
  width:270px;
  padding:0.5rem 0.75rem;
  margin-top:10px;
}
.alert-dismissible .close{
  padding:0.5rem 0.75rem;
}
.select-error{
  font-size: 0.75rem;
  color: #f1556c;
}
.select-invalid .multiselect__tags{
  border: #f1556c 1px solid !important;
}

.disabled-text.form-control:disabled{
    color: #999da0;
    background-color: #f2f2f2;
}

.copySuccessAlert{
  width: 50px;
  position:absolute;
  right: 10px;
  background-color: transparent;
  border: none;
  color: grey;
  padding: 0.1rem;
}


</style>
